var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.891 4.35a.625.625 0 0 0 0 .884L12.658 10 7.89 14.767a.625.625 0 0 0 .884.883l5.208-5.208a.625.625 0 0 0 0-.884L8.775 4.35a.625.625 0 0 0-.884 0Z",
  fill: "currentColor"
})));
export default SvgIconMore;